// extracted by mini-css-extract-plugin
export var inline = "_vn-0";